import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-content-no-image">
          <div className="about-text">
            <h2>About Me</h2>
            <p>
              I'm an AI Engineer currently building production-grade AI systems at Telnova Solutions,
              combining LLM applications, computer vision pipelines, and workflow automation to solve
              real operational problems.
            </p>
            <p>
              My work focuses on agentic AI, RAG systems, and scalable inference for real-world products.
              As a former Google Developer Student Club (GDSC) Founder & Lead, I organized 12+ AI workshops
              attended by over 300 students, led a 25-member technical team, and continue to turn complex
              AI ideas into practical systems with measurable impact.
            </p>
            <div className="about-stats">
              <div className="stat">
                <h3>6+</h3>
                <p>ML Projects Completed</p>
              </div>
              <div className="stat">
                <h3>1+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat">
                <h3>300+</h3>
                <p>Students Trained</p>
              </div>
              <div className="stat">
                <h3>#2</h3>
                <p>AI Research - Egypt (Favikon 2025)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
